import { render, staticRenderFns } from "./PlayIndex.vue?vue&type=template&id=6c9cc5bf&scoped=true&"
import script from "./PlayIndex.vue?vue&type=script&lang=js&"
export * from "./PlayIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c9cc5bf",
  null
  
)

export default component.exports